import { useDispatch } from 'react-redux';
import {
  editTile,
  triggerDeleteModal,
  acceptTile,
  ignoreTile,
  undoIgnoreTile,
  moveTilesToProof,
  copyTile,
} from '../actions.jsx';

const useHandleTiles = () => {
  const dispatch = useDispatch();

  return {
    undoIgnoreTile: ({ id, ignored, status }) =>
      dispatch(undoIgnoreTile({ id, ignored, status })),
    deleteTile: ({ ignored, status, id }) =>
      dispatch(triggerDeleteModal({ ignored, status, id })),
    ignoreTile: ({ id }) => dispatch(ignoreTile({ tileId: id })),
    acceptTile: ({ id, ignored, status }) =>
      dispatch(acceptTile({ id, ignored, status })),
    editTile: ({ id, ignored, status, planDate, editPath }) =>
      dispatch(editTile({ id, ignored, status, planDate, editPath })),
    moveTileToProof: ({ id }) => dispatch(moveTilesToProof([id])),
    copyTile: ({ id, ignored, status }) =>
      dispatch(copyTile({ id, ignored, status })),
  };
};

export default useHandleTiles;
